// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2YirN","empty":"ModalGraph_empty__-0Mf6"};